import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [form, setForm] = useState({ p1: "", p2: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.p1.length < 6) return toast.error(t("auth.tooShort"));
    if (form.p1 !== form.p2) return toast.error(t("auth.mismatch"));
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: form.p1 });
      toast.success(t("auth.resetSuccess"));
      navigate("/autentificare");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="border border-slate-200 p-8" data-testid="reset-password-page">
        <h1 className="text-3xl font-black tracking-tight mb-8">{t("auth.resetTitle")}</h1>
        {!token ? (
          <p className="text-sm text-red-600" data-testid="reset-invalid">{t("auth.invalidLink")} <Link to="/recuperare-parola" className="text-orange-600 font-semibold hover:underline">{t("auth.forgotLink")}</Link></p>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div>
              <label className="text-xs uppercase tracking-wide font-bold text-slate-500">{t("auth.newPassword")}</label>
              <Input required type="password" value={form.p1} onChange={(e) => setForm({ ...form, p1: e.target.value })} className="rounded-none border-slate-300 h-12 mt-2" data-testid="reset-password-1" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wide font-bold text-slate-500">{t("auth.confirmPassword")}</label>
              <Input required type="password" value={form.p2} onChange={(e) => setForm({ ...form, p2: e.target.value })} className="rounded-none border-slate-300 h-12 mt-2" data-testid="reset-password-2" />
            </div>
            <button disabled={loading} className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white px-6 py-4 font-bold uppercase tracking-wide text-sm transition-colors" data-testid="reset-submit">
              {loading ? t("auth.processing") : t("auth.resetBtn")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
